//home模块专享的小仓库
//任何的小仓库都需要:state、mutations、actions、getters 
import { reqUserInofo, getGlobalInfos } from '@/api/'
import { reqBanner, getCompany, getMenuBrand,countCustomerVisits } from '@/api/web'
import { getCountData } from '@/api/proxy'
let actions = {
    //获取用户数据
    async getUserInofo({ commit }) {
        try {
            //获取用户数据
            let req = await reqUserInofo()
            console.log('获取用户信息',req)
            commit("SETUSERINFO", req)
            // 统计访问量
            let parms={}
            parms.url=location.href
            console.log(parms)
            await countCustomerVisits(parms)
            // console.log('流量统计',reqs)
            return req
        } catch (error) {
            console.error(error)
        }
      
    },
    //获取用吉祥币
    async getGlobalInfos({ commit, state, dispatch }) {
        try {
            // 如果 wxData 数据不完整，先获取用户信息
            if (!state.wxData.id || !state.wxData.aid) {
                await dispatch('getUserInofo');
            }
             
            const { aid, id } = state.wxData;
            const req = await getGlobalInfos({ aid, wxid: id });
            
            if (req.state === 'ok') {
                console.log('获取吉祥币数量',req)
                commit("SETLUCKYCOIN", req);
                return req;
            }
        } catch (error) {
            console.error(error);
        }
    },
    // 获取通知中心统计
    async getCountData({ commit, state, dispatch }) {
        try {
            // 如果 wxData 数据不完整，先获取用户信息
            if (!state.wxData.id || !state.wxData.aid) {
                await dispatch('getUserInofo');
            }
            const { aid, id } = state.wxData;
            const req = await getCountData({ aid, wxid: id });
            // console.log(req.data)
            if (req.state === 'ok') {
                commit("SETNOTECONUT", req.data);
                return req.data;
            }
        } catch (error) {
            console.error(error);
        }
    },
    // 获取轮播图
    async getBanner({ commit, state }) {
        try {
            let req = await reqBanner()
            if (req.code == 200) {
                commit("SETBANNER", req.data)
            }
        } catch (error) {
            console.error(error)
        }
    },
    // 获取公司信息
    async getCompany({ commit, state }) {
        try {
            let req = await getCompany()
            if (req.code == 200) {
                commit("SETCOMPANY", req.data)
            }
        } catch (error) {
            console.error(error)
        }
    },
    // 获取二级分类图
    async getMenuBrand({ commit, state }) {
        try {
            let req = await getMenuBrand()
            if (req.code == 200) {
                commit("SETIMGARR", req.data)
            }
        } catch (error) {
            console.log(error)
        }
    }
}

//唯一可以修改仓库数据地方
let mutations = {
    // 路由选中下标赋值state
    SETACTIVE(state, active) {
        state.activeRoute = active
    },
    // 设置用户信息state
    SETUSERINFO(state, userinfo) {
        if (userinfo && userinfo.wxData && userinfo.wxData.id) {
            state.waDatas = userinfo.waDatas
            state.wxData = userinfo.wxData
            state.wxDatas = userinfo.wxDatas
            return true
        }
    },
    // 退出登录state
    LOGOUT(state) {
        state.waDatas = []
        state.wxData = {}
        state.wxDatas = []
    },
    // 设置吉祥币state
    SETLUCKYCOIN(state, GlobalInfos) {
        state.luckyCount = GlobalInfos.data.luckyCount
        state.expiredCount = GlobalInfos.data.expiredCount
        state.consumeCount = GlobalInfos.data.consumeCount
        state.annualCount=GlobalInfos.data.annualCount
        state.queryCount=GlobalInfos.data.queryCount
        state.autoUpCount=GlobalInfos.data.autoUpCount
    },
    // 设置通知统计state
    SETNOTECONUT(state, noteCount) {
        state.noteCount = noteCount
    },
    // 设置轮播图state
    SETBANNER(state, bannerinfo) {
        state.banner = bannerinfo
    },
    // 设置公司信息
    SETCOMPANY(state, Company) {
        state.Company = Company
    },
    // 设置二级分类图片state
    SETIMGARR(state, imgArr) {
        state.imgArr = imgArr
    },
}
//仓库计算属性
let getters = {}

//仓库存储数据的地方
let state = {
    // 顶部导航选中下标
    activeRoute: 0,
    waDatas: [],//账号集
    wxData: {},//用户信息
    wxDatas: [],//我的统计
    luckyCount: 0,//剩余吉祥币个数
    expiredCount: 0,//已过期
    consumeCount: 0, //预计消耗
    autoUpCount:0,//自动更新统计
    queryCount:0,//剩余检索数
    annualCount:0,//年费账单
    banner: [],//首页轮播
    Company: {},//底部公司信息
    imgArr: {},
    noteCount: {}
}

//对外暴露小仓库
export default {
    // 开启命名空间
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}




